type NoFeedSectionProps = {
    noFeeText?: string;
    upcomingText?: string;
};

export function NoFeedSection(data: NoFeedSectionProps = {}) {
    
    const {
        noFeeText = 'No reviews found :(',
        upcomingText = 'Please check your url is correct or try entering different one.'
    } = data;

    function render() {
        return /*html*/`
        <img src="/images/No-Import-Feed.svg" alt="No Import Feed" class="mb-4">

        <div class="max-w-sm mx-auto">
            <p class="mt-2 font-medium text-gray-800 dark:text-neutral-200">
                ${noFeeText}
            </p>
            <p class="mb-5 text-sm text-gray-500 dark:text-neutral-500">
                ${upcomingText}
            </p>
        </div>
        `;
    }

    return {
        render,
    };
}